import React, { useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import {
  get as getLocalStorage,
  set as setLocalStorage,
} from 'lib/storage/isomorphicLocalStorage'
import { LOYALTY_DISMISS_POINTS_DEDUCTION_MODAL_STORAGE_KEY } from 'loyalty/constants/loyaltyConfig'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

function LoyaltyPointsDeductionInfoModal() {
  const intl = useIntl()
  const programDisplayName = getLoyaltyProgramDisplayName()
  const { resolve } = useModalElementContext()

  const title = intl.formatMessage({
    id: '5Qa/9HO0sn',
    defaultMessage: 'Your points now go further',
    description: 'Title for modal explaining loyalty points deduction/calculation changes',
  })
  const primaryActionText = intl.formatMessage({
    id: 'Ef6NBmuai4',
    defaultMessage: 'Got it',
    description: 'Primary button text to dismiss the points deduction info modal',
  })

  const handlePrimaryActionClick = useCallback(() => {
    if (!getLocalStorage(LOYALTY_DISMISS_POINTS_DEDUCTION_MODAL_STORAGE_KEY)) {
      setLocalStorage(LOYALTY_DISMISS_POINTS_DEDUCTION_MODAL_STORAGE_KEY, 1)
    }
    resolve()
  }, [resolve])

  return <Modal
    title={title}
    primaryActionText={primaryActionText}
    onPrimaryActionClick={handlePrimaryActionClick}
  >
    <Group gap={16} direction="vertical">
      <BodyText variant="medium" colour="neutral-two">
        <FormattedMessage
          id="HvA6iYoVpw"
          defaultMessage="We’ve made a small update to how your {programDisplayName} points are calculated. It’s now simpler to understand and gives you more value when you redeem.{br}{br}Your balance has changed but the dollar value at checkout remains the same. In fact, each point now gives you more towards your next escape.{br}{br}No action needed. Your points and rewards are ready when you are."
          description="Explanation of loyalty points calculation changes and reassurance about point value"
          values={{ programDisplayName, br: <br /> }}
        />
      </BodyText>
    </Group>
  </Modal>
}

export default LoyaltyPointsDeductionInfoModal
